import { useStoreState } from "../store/useStore";
import useFetch from "./useFetch";

export type tokenParamsState = {
  lang: string;
};

const useLangUpdate = () => {
  const { baseUrl } = useStoreState();

  const { post } = useFetch(baseUrl);

  const LangUpdate = async (params: tokenParamsState) => {
    return post(`uapi/v1/uc/user/lang/update`, params);
  };

  return {
    LangUpdate
  };
};

export default useLangUpdate;
